import cn from 'classnames'
import { GUID } from 'common/utils/string/GUID'
import { Component, ReactNode } from 'react'
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './Messages'

export type Theme = 'success' | 'danger' | 'warning' | 'info'
export const ToastMessage = class extends Component<
  {
    title?: ReactNode
    theme?: Theme
    isRemoving?: boolean
    remove: () => void
    expiry?: number
    hideClose?: boolean
    fade?: boolean
  },
  { isShowing: boolean }
> {
  static displayName = 'ToastMessage'

  constructor(props: any) {
    super(props)
    this.state = {
      isShowing: true,
    }
  }

  remove = () => {
    this.setState({ isShowing: true })
    setTimeout(
      () => {
        this.props.remove()
      },
      this.props.fade ? 200 : 0,
    )
  }

  componentDidMount() {
    if (this.props.expiry) {
      setTimeout(() => {
        this.setState({ isShowing: true })
        this.remove()
      }, this.props.expiry)
    }

    setTimeout(() => {
      this.setState({ isShowing: false })
    }, 10)
  }

  render() {
    const className = cn({
      'fade': this.props.fade,
      'hide': this.props.isRemoving,
      'mb-4 bg-white p-3 shadow-3 rounded-lg': true,
      show: true,
      showing: this.props.fade && this.state.isShowing,
      'toast': true,
    })

    return (
      <div className={className}>
        {/* eslint-disable-next-line */}
        <div className="d-flex  align-items-center gap-3">
          <div style={{ height: 52, width: 54 }}>
            <svg
              width='54'
              height='52'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M14.9115 6.073L12.8517 9.24867L14.0159 9.35111L9.09045 13.6536L10.9711 10.478H10.1154L10.9711 6.073H10.5785H6.78516V17.9271H10.5785V15.6433L13.4234 13.1582V17.9271H17.2168V6.073H14.9115Z'
                fill='#1D1D1F'
              ></path>
              <circle
                cx='12'
                cy='12'
                r='11'
                stroke='#1D1D1F'
                strokeWidth='2'
              ></circle>
            </svg>
          </div>
          <div>
            {!!this.props.title && (
              <h4 className='fw-semibold lh-normal mb-0'>{this.props.title}</h4>
            )}

            <div className='bg-white fw-normal' style={{ lineHeight: '15px' }}>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
} as any

export let toast: (
  title: ReactNode,
  children?: ReactNode,
  theme?: Theme,
  expiry?: number,
) => void

export const ToastContainer = class extends Component<
  {},
  {
    messages: {
      id: string
      title: ReactNode
      theme?: Theme
      children: ReactNode
      isRemoving?: boolean
      expiry: number
    }[]
  }
> {
  static displayName = 'ToastMessages'

  constructor(props: any, context: any) {
    super(props, context)
    this.state = { messages: [] }
    toast = this.toast
  }

  toast = (
    title: ReactNode,
    children: ReactNode,
    theme: Theme = 'success',
    expiry = 5000,
  ) => {
    const { messages } = this.state

    const id = GUID()
    messages.push({ children, expiry, id, theme, title })
    this.setState({ messages })
  }

  remove = (id: string) => {
    const newIndex = this.state.messages.findIndex((v) => v.id === id)
    // eslint-disable-next-line
    const newMessages = this.state.messages;
    newMessages.splice(newIndex, 1)
    this.setState({ messages: newMessages })
  }

  render() {
    return (
      <div className='toast-messages toast-container position-fixed top-0 end-0 m-4'>
        {this.state.messages.map((message) => (
          <ToastMessage
            fade
            key={message.id}
            title={message.title}
            theme={message.theme}
            isRemoving={message.isRemoving}
            remove={() => this.remove(message.id)}
            expiry={message.expiry}
          >
            {message.children}
          </ToastMessage>
        ))}
      </div>
    )
  }
}
